import styled from 'styled-components';

export const FlexBox = styled.div`
  align-items: ${({ align }) => align};
  background: ${({ bg, theme }) => (bg === 'theme' ? theme.boxbg : bg)};
  display: flex;
  flex: ${({ flex }) => flex};
  flex-basis: ${({ basis }) => basis};
  flex-direction: ${({ direction }) => direction};
  flex-wrap: ${({ wrap }) => wrap || 'wrap'};
  height: ${({ height }) => height};
  justify-content: ${({ justify }) => justify};
  margin: ${({ margin }) => margin};
  padding: ${({ padding }) => padding};
  align-content: ${({ content }) => content};
  align-items: ${({ alignItems }) => alignItems};
  width: ${({ width }) => width};
`;

export const BorderedFlexBox = styled(FlexBox)`
  border: 1px solid ${({ theme }) => theme.border || '#eee'};
  height: ${({ height }) => height};
  padding: 0;
  margin: ${({ margin }) => margin || '5px'};
  user-select: none;
`;

export default FlexBox;
